import * as React from 'react';

const SvgWaveOneDesk = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1518 193"
    fill="none"
    {...props}
  >
    <g clipPath="url(#header_wave_desk_svg__a)">
      <path
        fill="url(#header_wave_desk_svg__b)"
        d="M1523.04 141c-80.38-12-216.36-77.853-375.8-69.186-159.447 8.666-229.879 103.166-388.004 112-158.125 8.833-225.875-73.667-384-75C217.111 107.48 110.716 238.033-1.289 176.2-113.294 114.366-541.55-15.334-159.414-171 222.721-326.667 1417.88-487.667 1832.96-571"
        opacity={0.05}
      />
      <path
        fill="url(#header_wave_desk_svg__c)"
        d="M1523.04 115c-80.38-12-226.39-66.267-385.83-57.6-159.442 8.667-221.374 90.367-379.499 99.2-158.125 8.833-221.375-55.467-379.5-56.8-158.125-1.333-267.495 112.233-379.5 50.4C-113.294 88.367-541.549-41.333-159.414-197 222.722-352.667 1417.88-513.666 1832.96-597"
        opacity={0.53}
      />
      <path
        fill="url(#header_wave_desk_svg__d)"
        d="M1522.04 76c-80.38-12-185.36-82.853-344.8-74.186-159.45 8.666-264.879 122.166-423.004 131-158.125 8.833-218.9-70.68-377.025-72.014-158.125-1.333-267.495 112.233-379.5 50.4C-114.294 49.367-620.635-272.271-238.5-427.937 143.635-583.604 1416.88-552.667 1831.96-636"
      />
    </g>
    <defs>
      <linearGradient
        id="header_wave_desk_svg__b"
        x1={-105563}
        x2={-105563}
        y1={196.635}
        y2={-76367.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3896B2" />
      </linearGradient>
      <linearGradient
        id="header_wave_desk_svg__c"
        x1={-105563}
        x2={-105563}
        y1={168.635}
        y2={-76395.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3896B2" />
      </linearGradient>
      <linearGradient
        id="header_wave_desk_svg__d"
        x1={-105563}
        x2={-105563}
        y1={140.635}
        y2={-76423.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3896B2" />
      </linearGradient>
      <clipPath id="header_wave_desk_svg__a">
        <path fill="#fff" d="M1518 193H0V0h1518z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaveOneDesk;
